import { english } from "./en";

export const swedish = {
  common: {
    ok: 'OK',
    cancel: 'Avbryt',
    close: 'Stäng',
    save: 'Spara',
    continue: 'Fortsätt',
    delete: 'Ta bort',
    edit: 'Redigera',
    error: 'Ett fel uppstod, försök igen.',
    readMore: 'Läs mer...',
    back: 'Tillbaka',
  },
  lookup: {
    allCategories: 'Alla kategorier',
    allCompanies: 'Alla leverantörer',
    allColors: 'Alla färger',
    allSeasons: 'Alla säsonger',
    imageType: {
      0: 'Alla bildtyper',
      1: 'Miljöbilder',
      2: 'Produktbilder',
    }
  },
  home: {
    hero: {
      title: 'En av Sveriges största bildbanker inom hem & trägård, mode & skönhet och mat & dryck',
      imageBelongsTo: 'Bilden tillhör',
    },
    search: {
      tags: {
        placeholder: 'Sök efter bilder på sökord, t.ex. Hus, Inredning, Kök osv...',
        noData: 'Inga sökord hittades.'
      },
      showOnlyNewProducts: 'Visa endast produktnyheter',
    },
    images: {
      loadMoreImages: 'Läs in fler bilder',
      noImagesFound: 'Inga bilder hittades.',
      noImagesFoundText: 'Försök igen med t.ex. andra sökord för att bredda sökningen.',
      contactUsIfMissing: 'Kontakta oss på <a href="mailto:info@pretopia.se">info@pretopia.se</a> om du saknar några bilder från våra leverantörer.',
      newProduct: 'Produktnyhet',
      info: 'Info',
      download: 'Hämta bild',
      onlyJournalistTooltip: 'Endast journalister har behörighet att ladda ner bilder från andra leverantörer.',
      missingCountryTooltip: 'Du kan inte ladda ner denna bild på grund av att leverantören valt att deras bilder inte ska publiceras i ditt land. <br />En orsak till det kan t ex vara att det inte finns någon återförsäljare där.',
      missingCountryInfoTitle: 'Landsval matchar inte',
      missingCountryInfoContent: 'Den aktuella leverantören har valt att deras bilder endast ska publiceras i',
      onlyJournalistInfoTitle: 'Du har ej behörighet att ladda ner bilder',
      onlyJournalistInfoContent: 'Endast journalister har behörighet att ladda ner bilder från andra leverantörer.'
    },
    companyButtons: {
      title: 'Leverantörer som vi har i vår bildbank'
    },
    mainInfoBoxes: {
      title: 'Pretopia - en bildbank för tidningar och magasin',
      content: 'För dig som är frilansskribent eller arbetar på redaktion kan du här snabbt och enkelt söka efter bilder från leverantörer inom hem, inredning och trädgård.',
      boxTitle1: 'Exponering mot redaktioner inom hem & trädgård, mode & skönhet samt mat & dryck',
      boxContent1: 'För dig som är tillverkare eller leverantör och vill nå ut med dina produkter och nyheter är Pretopia en utmärkt plattform. Här har du möjligheten att nå ut till frilansskribenter och redaktioner på tidningar och magasin i hela Europa. Journalister från många av de stora magasinen använder idag vår bildbank till sitt redaktionella material. Ladda upp dina bilder så sköter Pretopia resten.',
      boxContentLinkText1: 'Skapa ett konto redan idag',
      boxTitle2: 'Enkel bildhantering',
      boxContent2: 'För dig som vill underlätta arbetsbelastningen kan du outsourca din bildhantering till oss. När journalister eller dina kunder vill titta på pressbilder för nedladdning kan du enkelt hänvisa till oss. Om du behöver hjälp att konvertera eller redigera bilder hjälper vi dig med det. Med vårt verktyg för uppladdning, taggning och kategorisering av dina bilder slipper du tänka och låta bildbanken sköta jobbet.',
      boxContentLinkText2: 'Vill du ha hjälp - kontakta oss!',
      boxTitle3: 'Ladda ner enkelt och snabbt',
      boxContent3: 'För dig som är frilansare eller jobbar på redaktion är Pretopia ett utmärkt verktyg. Eftersom vi har flera års erfarenhet av redaktionellt arbete vet vi att du som jobbar på redaktion eller som frilansare lägger ner oproportionerligt mycket tid på jaga rätt på de bilder och nyheter du behöver för till exempel inspirations-, nyhets- eller plocksidor. Bildbanken rymmer både frilagda produktbilder och miljöbilder. Vårt mål är att du inte behöver leta dig längre än till Pretopia ',
      boxContentLinkText3: 'Skapa ett konto',
      boxContentLinkText4: 'och börja ladda hem för allt vad tygen håller - helt kostnadsfritt!',
    },
    customerQuotes: {
      meyenberg: {
        quote: 'Pretopias Bildbank är lätt att använda, och har gett Meyenberg fin publicitet i flera medier. Jag värdeätter också proffsig och snabb återkoppling, samt översiktliga månadsrapporter.',
        title: 'Grundare/VD',
      },
      miljogarden: {
        quote: 'Efter ungefär ett år med Pretopia har vår synlighet i relevanta magasin ökat markant. Detta har varit en fantastisk möjlighet för oss att sprida vårt varumärke Miljögården.com till en bredare publik, vilket är något vi har strävat efter under en lång tid. Pretopias tjänst har inte bara varit kostnadseffektiv och lättanvänd,         utan personalen har också varit otroligt engagerad och hjälpsam, vilket har gjort att samarbetet blir positivt och ett rent nöje.',
        title: 'Marknadsansvarig',
      },
      haboGruppen: {
        quote: 'Pretopia har hjälpt oss under flera år att nå ut med bilder för våra varumärken Habo och Muurikka. Det har gett oss en större synlighet i olika kanaler, inte minst i flera inredningsmagasin. Vi kan när vi vill byta ut bilder, vilket gör bildbanken mycket flexibel och med ett innehåll som vi enkelt uppdaterar vid exempelvis produktlanseringar. Varje månad får vi tydliga rapporter, där vi ser vilka bilder som laddats ner och det ger oss bra insikter över hur våra bilder används.',
        title: 'Marknads- och kommunikationschef',
      },
      scandinaviskSpismiljo: {
        quote: 'Vi är väldigt nöjda med vårt samarbete med Pretopia. Vi har fått en helt annan synlighet och närvaro i media sedan vi började använda verktyget i början av 2022. Personalen är mycket serviceinriktade och proffsiga och det är snabbt och enkelt att ladda upp bilder och information på deras sida. Kan verkligen rekommendera att börja använda deras verktyg. Stort Tack för vårt samarbete!',
        title: 'Försäljning/marknadschef',
      },
      beslagDesign: {
        quote: 'Pretopia har hjälpt oss att nå ut till relevant press med vårt bildmaterial på ett effektivt och smidigt sätt, vilket har resulterat i att vi har fått många fler pressklipp än tidigare. Vi är också tacksamma för den månatliga sammanställningen, som ger oss en översikt över vilka bilder som laddats ner och använts. Pretopia har verkligen underlättat vår pressbearbetning och vi kan varmt rekommendera deras tjänster.',
        title: 'Medie- och kommunikationschef',
      },
      sweefFurniture: {
        quote: 'Vi på Sweef Furniture är väldigt nöjda med bildbanken Pretopia, samt den service och tilläggstjänster som tillkommer. Antal pressklipp och införanden vi fått är över förväntan! Det är också väldigt uppskattat att få snabba notiser om våra omnämningar. Vi har länge efterfrågat en samlad bildbank för inredningsbranschen, vilket vi nu uppskattar med Pretopia.',
        title: 'PR Manager',
      },
      almedahlsHome: {
        quote: 'Vi har använt i Pretopia sedan början av 2022 och är jättenöjda. Pretopias personal visar stort engagemang och tjänsten förenklar mycket för oss. Det är lätt att ladda upp bilder, texter och att byta ut dem när vi har nya vi vill visa. Kunder och press hittar oss och vi har kommit med i många tidningar. Vi kan varmt rekommendera Pretopia!',
        title: 'Sales & marketing',
      },
      byBenson: {
        quote: 'När vi påbörjade samarbetet med Pretopia visste vi inte så mycket om dem eller om utfallet, men vi är mer än nöjda! Och varje månad levererar de fina sammanställningar på mycket fina publiceringar. Stort tack för det. Så smidig tjänst!',
        title: 'VD',
      },
      idyllien: {
        quote: 'Vi är jättenöjda med Pretopia - vi har snabbt nått ut till fler och nya kunder genom att finnas på Pretopia och på så sätt kommit med i flera populära tidningar!',
        title: 'Grundare',
      },
      potPaws: {
        quote: 'Ensam är inte stark. Under min resa med POT PAWS® kruktassar har jag gjort det mesta ensam/själv med några undantag. Ett av dessa är att jag har tagit hjälp av proffsiga, smarta Pretopia bildbank för att mina bilder lättare ska kunna nå ut. Det har visat sig vara en riktigt god idé. Hela 13 gånger har mina POT PAWS® varit med i tidningar under våren! Har känts helt fantastiskt och lite magiskt att se hur de ”tassat” ut i världen. Tacksam för att ni på Pretopia gav mig möjlighet att vara med i er smarta bildbank och rekommenderar detta varmt till alla som vill nå ut enklare med sina produkter.',
        title: 'Ägare och grundare',
      },
      himlekok: {
        quote: 'Vi har använt Pretopia under två års tid och är otroligt nöjda. Pretopia är både professionella och engagerade i sina uppdrag. Två egenskaper som vi som kund verkligen värdesätter och som har resulterat i fin publicitet samt exponering av vårt varumärke.',
        title: 'Vice VD',
      },
      anebyhusgruppen: {
        quote: 'Vi har använt Pretopia i ungefär ett år nu och vi märker att våra bilder får ett större genomslag än innan och används frekvent i olika medier. Verktyget är enkelt och användarvänligt och är ett smidigt sätt att nå ut till nya och gamla samarbetspartners.',
        title: 'Marknadsansvarig',
      },
      ireMobelAB: {
        quote: 'Pretopia bildbank är lätthanterlig, smidig & ger bra återkoppling på nedladdningar.<br> Alltid hjälpsamma & har ett trevligt bemötande. <br>Tummen upp!',
        title: 'Marknadskoordinator / Marketing Coordinator',
      },
      dCor: {
        quote: 'Pretopia har varit ett kostnadseffektivt sätt för oss att få publicitet i flera magasin under det senaste året. Verktyget är dessutom lättanvänt och samarbetet fungerar mycket bra.',
        title: 'Sales',
      },
    },
  },
  aboutUs: {
    title: 'Om oss',
    content: 'Pretopias bildbank är ett litet men kraftfullt verktyg för dig som är leverantör och vill nå ut till skribenter och redaktörer på landets stora tidningar och magasin inom hem, inredning och trädgård, mode och skönhet samt mat och dryck. Som verksam inom press och media skapar du enkelt ett konto och laddar ner bilder gratis. Vi på Pretopia gör i huvudsak två saker, dels tillhandahåller vi en bildbank som både har en bred variation samt innehåller både miljö- och produktbilder och dels använder vi vårt kontaktnät av frilansare och redaktioner som vi skickar ut nyhetsbrev och produktlanseringar till.',
    subTitle1: 'GEDIGEN BRANSCHERFARENHET',
    subContent1: 'Hos oss finns en gedigen erfarenhet inom tidningsbranschen och det gör att vi vet vilka utmaningar som finns hos både leverantörer och de som är verksamma på redaktioner. Som leverantör vet vi att det kan vara svårt att få effektiv exponering mot skribenter och redaktörer när man gör nya produktlanseringar eller i ren allmänhet vill öka medvetenheten kring sin produktportfolio. Vi vet också att du som är verksam inom media har en stor utmaning att hitta rätt bilder till ditt redaktionella material, något som många gånger kan vara tidskrävande. <br>Med denna kunskap i bakhuvudet har vi skapat en "win/win"- situation mellan leverantörer och media. Vårt mål har blivit att knyta till oss leverantörer som medför ett variationsrikt utbud av pressbilder till våra anslutna redaktioner och frilansare.',
    subTitle2: 'NÅGRA AV BRANSCHENS STÖRSTA TIDNINGAR FINNS HOS OSS',
    subContent2: 'Hos oss hittar du Plaza Kök&Bad, Plaza Villa&Hus, Hem Ljuva Hem, Aftonbladet Härligt Hemma, Sköna hem, Lantliv, Amelia, Aller Media, Residence, MediaExtra, HusExtra samt en mängd andra titlar och frilansare. För dig som är leverantör blir därför Pretopias bildbank en oerhört värdefull tillgång i din marknadsföringsarsenal.',
    subTitle3: 'FRÅGOR OCH FEEDBACK?',
    subContent3: 'Skicka oss ett mail till adressen <a href="mailto:info@pretopia.se">info@pretopia.se</a>',
    imageBelongsTo: 'Bild tillhör',
  },
  contactUs: {
    address: 'Postadress',
    phone: 'Tel',
    email: 'E-post',
    jennySubtitle: 'VD & delägare',
    mickeSubtitle: 'Utvecklare & delägare',
    ceciliaSubtitle: 'Social media manager',
    contactForm: {
      title: 'Vad kan vi hjälpa dig med?',
      subtext1: 'Har du frågor om våra tjänster och abonnemang?',
      subtext2: 'Skicka ett meddelande till oss så återkommer vi så snart som möjligt.',
      subtitle: 'Lämna dina uppgifter så kontaktar vi dig',
      companyName: 'Företagsnamn',
      name: 'Ditt namn',
      emailOrPhone: 'E-post eller telefon *',
      message: 'Meddelande *',
      send: 'Skicka',
      thanks: 'Tack för ditt meddelande!',
    }
  },
  vendorPrice: {
    title: 'Välj rätt abonnemang för dig',
    subtitle: 'Det finns en lösning för varje typ av företag, oavsett storlek.',
    contactUs: 'Kontakta oss',
    contactUsLinkText: 'Kontakta oss så pratar vi igenom vad ni har för önskemål.',
    info: 'Paketen kan när som helst under året uppgraderas till ett större paket.<br /> Det går även att köpa till utrymme för fler antal bilder eller nyhetsbrev, oavsett paket. Hör av er till oss hur många bilder ni vill att ert konto ska rymma eller hur många nyhetsbrev ni vill ha så återkommer vi med offert. <br /> Vi erbjuder även total administration av kontot då vi byter ut, tar bort och lägger till bilder efter ert önskemål.<br />',
    infoTitle: 'Passar inte paketen dig? <br />Vi skräddarsyr ett paket efter dina önskemål!',
    package: {
      basic: {
        title: 'Nå landets viktigaste redaktioner och frilansare.',
        value1: 'Medlem i bildbanken och därmed unik tillgång till landets stora magasin',
        value2: '30st bilder i bildbanken',
        value3: 'Kostnadsfri support',
        value4: 'Statistik över nedladdningar',
        value5: 'Månatliga ROI-rapporter',
        price: '550 kr/mån utan bindningstid, 1 månads uppsägningstid. Bindningstid ett år vid årspaket då hela beloppet faktureras vid ett och samma tillfälle, 6 050 kr/år (550 kr/rabatt).<br /> Pris PUFF-medlem: 4 500 kr/år',
      },
      standard: {
        mostPopular: 'Populärast',
        title: 'För dig som vill ha ut mer av ditt medlemsskap hos oss.',
        value1: 'Medlem i bildbanken och därmed unik tillgång till landets stora magasin',
        value2: 'Publicitet under nyhetssidan på Pretopias startsida av minst ett instagram inlägg',
        value3: '50st bilder i bildbanken',
        value4: '5 exponeringar i sociala medier (i samråd med er)',
        value5: '1 eget nyhetsbrev (i samråd med er)',
        value6: 'Kostnadsfri support',
        value7: 'Statistik över nedladdningar',
        value8: 'Månatliga ROI-rapporter',
        value9: 'Sporadisk medverkan i sociala medier kan förekomma',
        price: '1 070 kr/mån. Bindningstid 12 månader. Ingen automatisk förnyelse - vi kontaktar er. <br /> Om beloppet istället faktureras vid ett och samma tillfälle, 11 770 kr/år (1 070 kr rabatt).<br /> Pris PUFF-medlem: 9 000 kr/år',
      },
      premium: {
        title: 'För dig som vill synas ännu mer.',
        value1: 'Medlem i bildbanken och därmed unik tillgång till landets stora magasin',
        value2: 'Publicitet under nyhetssidan på Pretopias startsida av minst ett instagram inlägg',
        value3: 'Kostnadsfri rådgivning',
        value4: '100st bilder i bildbanken',
        value5: '10 exponeringar i sociala medier (i samråd med er)',
        value6: '2 egna nyhetsbrev (i samråd med er)',
        value7: 'Kostnadsfri support',
        value8: 'Statistik över nedladdningar',
        value9: 'Månatliga ROI- rapporter',
        value10: 'Sporadisk medverkan i sociala medier kan förekomma',
        price: '1 700 kr/mån. Bindningstid 12 månader. Ingen automatisk förnyelse - vi kontaktar er. <br /> Om beloppet istället faktureras vid ett och samma tillfälle, 18 700 kr/år (1 700 kr rabatt).<br /> Pris PUFF-medlem: 15 000 kr/år'
      },
      premiumPlus: {
        title: 'För dig som vill ha lite mer av allt...',
        value1: 'Medlem i bildbanken och därmed unik tillgång till landets stora magasin',
        value2: 'Publicitet under nyhetssidan på Pretopias startsida av minst ett instagram inlägg',
        value3: 'Kostnadsfri rådgivning',
        value4: '150st bilder i bildbanken',
        value5: '12 exponeringar i sociala medier (i samråd med er)',
        value6: '3 egna nyhetsbrev (i samråd med er)',
        value7: 'Kostnadsfri support',
        value8: 'Statistik över nedladdningar',
        value9: 'Månatliga ROI- rapporter',
        value10: 'Sporadisk medverkan i sociala medier kan förekomma',
        price: '2 090 kr/mån. Bindningstid 12 månader. Ingen automatisk förnyelse - vi kontaktar er.<br /> Om beloppet istället faktureras vid ett och samma tillfälle, 22 990 kr/år (2 090 kr/rabatt).<br /> Pris PUFF-medlem: 18 000 kr/år'
      },
      grande: {
        title: 'Maximera ditt genomslag i alla kanaler',
        value1: 'Medlem i bildbanken och därmed unik tillgång till landets stora magasin',
        value2: 'Publicitet under nyhetssidan på Pretopias startsida av minst ett instagram inlägg',
        value3: 'Kostnadsfri rådgivning',
        value4: '200st bilder i bildbanken',
        value5: '15 exponeringar i sociala medier (i samråd med er)',
        value6: '4 egna nyhetsbrev (i samråd med er)',
        value7: 'Kostnadsfri support',
        value8: 'Statistik över nedladdningar',
        value9: 'Månatliga ROI- rapporter',
        value10: 'Sporadisk medverkan i sociala medier kan förekomma',
        price: '2 520 kr/mån. Bindningstid 12 månader. Ingen automatisk förnyelse - vi kontaktar er.<br /> Om beloppet istället faktureras vid ett och samma tillfälle, 27 720 kr/år (2 520 kr/rabatt).<br /> Pris PUFF-medlem: 21 500 kr/år'
      }
    }
  },
  resetPassword: {
    title: 'Skriv in ditt nya lösenord',
    password: 'Lösenord',
    passwordHint: 'Minst 6 tecken',
    passwordChangedMessage: 'Ditt lösenord har ändrats. Du kan nu logga in med ditt nya lösenord.',
  },
  vendors: {
    dashboard: {
      myProfile: 'Min profil',
      editAccountInformation: 'Redigera företagsinformation',
      company: 'Företag',
      name: 'Namn',
      orgNumber: 'Org.nr',
      address: 'Adress',
      postAddress: 'Postadress',
      email: 'E-post',
      phone: 'Telefon',
      description: 'Beskrivning',
      uploadImages: 'Ladda upp bilder',
      imageAdministration: 'Bildadministration',
      accountInfoText: 'Här kan du hantera dina bilder via bildadministrationen, se statistik eller spana in vilka redaktioner som laddat hem dina bilder. <br />Undrar du något så kontakta oss på <a href="mailto:info@pretopia.se">info@pretopia.se</a>',
      companyAccountInfoTitle: 'Företagsinformation',
      userAccountInfoTitle: 'Användarinformation',
      editInformation: 'Ändra uppgifterna',
      downloadTop3: 'Nedladdade Top 3',
      downloads: 'nedladdningar',
      imagesForReview: 'Bilder för granskning',
      rejectedImages: 'Avvisade bilder',
      acceptedLanguages: 'Länder som dina bilder får publiceras i',
      youCanChangeThis: 'Du kan ändra dessa under "Ändra uppgifterna"',
    },
    list: {
      saveAllImages: 'Spara alla bilder',
      savedSuccessfullyMessage: 'Bilderna och informationen har sparats och har nu skickats till granskning.',
      savedButMissingInformationMessage: 'Bilderna och informationen har sparats men en eller flera bilder saknar <br />kategori, taggar och/eller färger och de kan inte flyttas till granskningen!',
      new: 'Nya',
      review: 'Under granskning',
      approved: 'Godkända',
      rejected: 'Avvisade',
      saveHintText: 'Kom ihåg att välja kategori och minst en tagg/nyckelord på varje bild för att den ska skickas till granskning.',
      removeSelectedImages: 'Ta bort valda bilder',
      removeErrorMessage: 'En eller flera bilder kunde inte tas bort.',
      selectAllImages: 'Markera alla bilder',
      selectAllImagesHintText: 'Tips: Du kan markera flera bilder genom att hålla ner CTRL eller SHIFT samtidigt som du klickar på bilderna',
      categoryMissing: 'Kategori saknas',
      uploadImages: 'Ladda upp bilder',
      imageInfoMessage1: 'Ladda upp bilderna genom att klicka på knappen här ovanför. <br />Därefter markerar du bilderna och fyller i information här under. <br />Det går bra att välja flera bilder samtidigt.',
      imageInfoMessage2: 'Sätt relevanta taggar/nyckelord på bilderna för att få användarna att träffa på just din bild när de söker.',
      imageInfoMessage3: 'När du är klar sparar du och bilderna skickas för granskning innan de blir sökbara!',
      tags: 'Taggar/Nyckelord',
      mainCategory: 'Huvudkategori',
      category: 'Kategori',
      description: 'Bildbeskrivning',
      descriptionInSwedish: 'Beskrivning på svenska',
      descriptionInEnglish: 'Beskrivning på engelska/annat språk',
      swedish: 'Svenska',
      english: 'Engelska',
      typeOfImage: 'Typ av bild',
      environmentImage: 'Miljöbild',
      productImage: 'Produktbild',
      color: 'Färg/Mönster',
      missingColorText: 'Saknar du någon färg? <a href="mailto:info@pretopia.se">Klicka här</a> för att skicka ett mail till oss.',
      price: 'Svenskt pris',
      englishPrice: 'Engelskt pris',
      season: 'Säsong',
      newProduct: 'Produkten är en nyhet',
      selectLaunchDate: 'Välj lanseringsdatum',
      externalUrl: 'Skriv in en länkadress om du vill hänvisa till egen bildbank eller hemsida',
      unsavedChangesTitle: 'Osparade ändringar',
      unsavedChangesMessage: 'Du har osparade ändringar.<br /> Vill du fortsätta utan att spara?',
    },
    approved: {
      nonApprovedImages: 'Inga bilder har blivit godkända',
      categoryMissing: 'Kategori saknas',
      changeVisibility: 'Ändra synlighet',
      nrOfDownloads: '{count} nedladdningar',
      editImage: 'Redigera bild',
      deleteImage: 'Ta bort bild',
    },
    rejected: {
      nonRejectedImages: 'Inga bilder har blivit avvisade',
      infoSavedWaitingForApproval: 'Bildinformationen har sparats och väntar nu på godkännande.',
      categoryMissing: 'Kategori saknas',
    },
    review: {
      nonReviewedImages: 'Inga bilder har sparats för granskning',
      categoryMissing: 'Kategori saknas',
    },
    upload: {
      uploadImages: 'Ladda upp bilder',
      dragDropText: 'Drag och släpp dina bilder här eller klicka här för att välja bilder på din dator.',
      imageSizeText: 'Bilderna bör vara större än 1,5 MB för att de ska kunna användas t.ex. i tryck.',
      uploadingImages: 'Laddar upp {fileCount} bild(er), vänligen vänta...',
      fileSizeWarning: 'Några av bilderna du försökte ladda upp är för liten i storlek. <br />Minsta storlek är 1,5 MB.',
      uploadError: 'Ett fel uppstod när en eller flera av bilderna skulle laddas upp.',
      file: 'Fil',
      uploadNotSupported: 'Din webbläsare stödjer inte filuppladdning!',
    }
  },
  components: {
    head: {
      menu: {
        home: 'Hem',
        contactUs: 'Kontakt',
        aboutUs: 'Om oss',
        createAccount: 'Skapa konto',
        myProfile: 'Min profil',
        myImages: 'Mina bilder',
        login: 'Logga in',
        logout: 'Logga ut',
        journalist: 'Journalist',
        loginAsJournalist: 'Logga in som journalist/användare',
        createAccoutAsJournalist: 'Skapa konto som journalist/användare',
        company: 'Leverantör',
        loginAsCompany: 'Logga in som leverantör',
        createAccountAsCompany: 'Skapa konto som leverantör',
        switchCompany: 'Byt företag',
      },
    },
    footer: {
      policy: 'Policy & Villkor',
      contactUs: 'Kontakta oss',
      followUs: 'Följ oss',
    },
    common: {
      category: 'Kategori',
      cookieSnackbarText: 'Vi använder kakor (cookies) för att webbplatsen ska fungera på ett bra sätt för dig. Genom att surfa vidare godkänner du detta.',
      whatIsCookies: 'Vad är kakor?',
      iUnderstand: 'Jag förstår',
      wordFromOurCustomers: 'Några ord från våra kunder',
      missingImages: 'Saknar du någon bild från våra leverantörer?',
      contactUsForHelp: 'Kontaka oss på <a href="mailto:info@pretopia.se">info@pretopia.se</a> så hjälper vi dig.',
      addItem: '+ Lägg till',
      addTagsHint: 'Tryck på ENTER eller TAB tangenten för att lägga till taggen',
      allCountries: 'Alla länder',
      selectAllCountries: 'Välj alla länder',
      countries: 'Länder',
    },
    dialog: {
      acceptLicense: {
        title: 'Licens Mediaanvändning',
        contentText1: 'Genom att bli användare hos Pretopia AB godkänner du följande licensvillkor:',
        contentText2: 'Leverantörerna till bilderna ska anges vid bildanvändning i såväl tryckta som digitala medier och hemsidor. Såvida inte någon fotograf står angiven till bilderna behöver endast leverantörens namn stå med.',
        contentText3: 'Genom att bli kund hos Pretopia AB godkänner leverantören följande licensvillkor:',
        contentText4: 'Leverantören är ensam och fullt ansvarig för de digitala bildfiler som de överför när de använder Pretopias bildbank. Leverantören har fullt ansvar för att de besitter rättigheterna till bilderna. Du garanterar att Pretopia eller någon av dess anställda inte hålls ansvarig för eventuella brister i efterlevnaden av denna skyldighet.',
        confirmLicense: 'Ja, jag godkänner licensvillkoret'
      },
      companySelect: {
        title: 'Välj företag',
        label: 'Välj företag...',
      },
      cookies: {
        title: 'Kakor (Cookies)',
        contentText1: 'En kaka (eller cookie) är en liten textfil som webbplatsen du besöker begär att få spara på din dator.',
        contentText2: 'Kakor och liknande tekniker används på många webbplatser för att ge en besökare tillgång till olika funktioner. Det går ibland att använda informationen i kakan för att följa hur användare surfar.',
        contentText3: 'Enligt lagen om elektronisk kommunikation ska alla som besöker en webbplats med kakor få tillgång till information om att webbplatsen innehåller kakor och ändamålet med användningen av kakor. Besökaren ska också lämna sitt samtycke till att kakor används.',
        contentText4: 'Undantag från detta är när kakor behövs för att överföra ett elektroniskt meddelande via ett elektroniskt kommunikationsnät eller när hanteringen är nödvändig för att tillhandahålla en tjänst som användaren uttryckligen har begärt.',
      },
      imageDetails: {
        newProduct: 'Produktnyhet',
        description: 'Beskrivning',
        launchDate: 'Lanseringsdatum',
        season: 'Säsong',
        price: 'Produktpris',
        externalUrl: 'Länk till leverantörens bildbank eller hemsida',
        clickHereToOpenExternalUrl: 'Klicka här för att komma till leverantören',
        company: 'Företag',
        phone: 'Telefon',
        email: 'E-post',
        imageInformation: 'Bildinformation',
        dimensions: 'Mått',
        imageAddedAt: 'Bilden lades in',
        download: 'Hämta bild',
        onlyJournalistTooltip: 'Endast journalister har behörighet att ladda ner bilder från andra leverantörer.',
        missingCountryTooltip: 'Du kan inte ladda ner denna bild på grund av att leverantören valt att deras bilder inte ska publiceras i ditt land. <br />En orsak till det kan t ex vara att det inte finns någon återförsäljare där.',
        missingCountryInfoTitle: 'Landsval matchar inte',
        missingCountryInfoContent: 'Den aktuella leverantören har valt att deras bilder endast ska publiceras i',
        onlyJournalistInfoTitle: 'Du har ej behörighet att ladda ner bilder',
        onlyJournalistInfoContent: 'Endast journalister har behörighet att ladda ner bilder från andra leverantörer.'
      },
      imageEditDetails: {
        message: 'Meddelande',
        note: 'OBS!',
        editWarningText: 'Om du redigerar godkända bilder kommer de att flyttas till "Under granskning".',
        description: 'Beskrivning',
        category: 'Kategori',
        tags: 'Taggar/Nyckelord',
        color: 'Färg/Mönster',
        typeOfImage: 'Typ av bild',
        environmentImage: 'Miljöbild',
        productImage: 'Produktbild',
        newProduct: 'Produktnyhet',
        launchDate: 'Lanseringsdatum',
        productIsNew: 'Produkten är en nyhet',
        selectLaunchDate: 'Välj lanseringsdatum',
        season: 'Säsong',
        price: 'Produktpris',
        swedishPrice: 'Svenskt pris',
        englishPrice: 'Engelskt pris',
        externalUrl: 'Länk till leverantörens bildbank eller hemsida',
        company: 'Företag',
        phone: 'Telefon',
        email: 'E-post',
        imageInformation: 'Bildinformation',
        dimensions: 'Mått',
        confirmDeleteTitle: 'Bekräfta borttagning',
        confirmDeleteText: 'Är du säker på att du vill ta bort den här bilden?',
        confirmDeleteButtonText: 'Ja, ta bort bilden',
        clickHereToOpenExternalUrl: 'Klicka här för att komma till leverantören',
        swedish: 'Svenska',
        english: 'Engelska',
      },
      login: {
        loginCompany: 'Logga in som leverantör',
        login: 'Logga in',
        email: 'E-post',
        password: 'Lösenord',
        loginFailedMessage1: 'Fel användarnamn/lösenord. Försök igen.',
        loginFailedMessage2: 'Om du nyligen skapat kontot och det ännut inte har blivit godkänt kommer du få ett mail från oss när du kan använda tjänsten. <br>Om du har frågor är du välkommen att kontakta oss på info@pretopia.se så hjälper vi dig.',
        forgotYourPassword: 'Har du glömt lösenordet?',
        noAccountLinkText: 'Har du inget konto? Klicka här för att skapa ett.',
      },
      resetPassword: {
        enterYourEmail: 'Skriv in din e-mailadress',
        emailAddress: 'E-postadress',
        resetError: 'E-mailadressen hittades inte eller kontot är inte aktivt.',
        sendResetMailSuccessMessage: 'Ett mail har skickats till dig med länk till återställningssidan.',
        missingAccount: 'Har du inget konto? Klicka här för att skapa ett.',
        resetPassword: 'Återställ lösenord',
        enterNewPassword: 'Skriv in ditt nya lösenord',
        password: 'Lösenord',
        passwordHint: 'Minst 6 tecken',
        resetSuccessMessage: 'Lösenordet är bytt och du kan nu logga in.',
      },
      signup: {
        createAccount: 'Skapa konto',
        selectUserType: 'Välj vem du är:',
        editorial: 'Redaktion',
        freelance: 'Frilans',
        company: 'Företag/Tidning *',
        publisher: 'Förlag',
        name: 'Ditt namn *',
        email: 'E-postadress *',
        emailExistsError: 'E-postadressen finns redan',
        password: 'Lösenord *',
        confirmPassword: 'Bekräfta lösenordet *',
        accept: 'Ja, jag godkänner',
        licenseTerms: 'licensvillkoren',
        readLicenseTerms: 'Läs licensvillkoren här',
        createAccountError: 'Ett fel uppstod. Kontrollera att alla fält är ifyllda och försök igen.',
        mandatory: 'Obligatoriskt',
        mandatoryAndMinChars: 'Obligatoriskt och minst 6 tecken',
        passwordNotMatch: 'Lösenorden måste matcha varandra',
        invalidEmail: 'Ogiltig epostadress',
        selectCountry: 'Välj land som du riktar dig mot *',
      },
      signupCompany: {
        createCompanyAccount: 'Skapa leverantörskonto',
        welcomeMessage: 'Kul att ni vill använda våra tjänster! <br />Fyll i uppgifterna här under så kontaktar vi er så snart som möjligt.',
        name: 'Företagsnamn *',
        contactName: 'Kontaktperson *',
        phoneOrEmail: 'Telefon eller Epost *',
        message: 'Meddelande',
        createAccountError: 'Ett fel uppstod. Kontrollera att alla fält är ifyllda och försök igen.',
        send: 'Skicka',
        mandatory: 'Obligatoriskt',
      },
      signupWaitingForVerification: {
        title: 'Välkommen till Pretopia!',
        contentText1: 'Tack för att du har skapat ett konto hos oss på Pretopia!',
        contentText2: 'Vi går igenom uppgifterna och återkopplar inom kort via mail.',
        contentText3: 'När ditt konto är godkänt kan du logga in och börja ladda ner bilder.',
      },
      userEdit: {
        editAccount: 'Redigera konto',
        selectUserType: 'Välj vem du är:',
        editorial: 'Redaktion',
        freelance: 'Frilans',
        company: 'Företag/Tidning *',
        publisher: 'Förlag',
        name: 'Ditt namn *',
        email: 'E-postadress',
        selectCountry: 'I vilket land kommer bilderna som du laddar ner att publiceras? *',
        otherMultipleCountriesSelected: 'Fler länder som dina nedladdade bilder kommer att publiceras i',
        editAccountError: 'Ett fel uppstod. Kontrollera att alla fält är ifyllda och försök igen.',
        mandatory: 'Obligatoriskt',
        password: 'Nytt lösenord *',
        confirmPassword: 'Bekräfta det nya lösenordet *',
        mandatoryAndMinChars: 'Obligatoriskt och minst 6 tecken',
        passwordNotMatch: 'Lösenorden måste matcha varandra',
        changePassword: 'Ändra lösenordet',
      },
    }
  }
}
